import React from "react";
import Slider from "src/components/slider";
import Button from "src/components/button";
import styles from "./excludeSession.module.scss";

interface IExcludeSession {
  show: boolean;
  onClose: () => void;
  onExclude: () => void;
  updating: boolean;
}

const ExcludeSession: React.FC<IExcludeSession> = ({
  show,
  onClose,
  onExclude,
  updating,
}) => {
  return (
    <Slider.Dialog
      show={show}
      onClose={onClose}
      width="400px"
      className={styles.container}
    >
      <Slider.Header className={styles.header}>
        <h1 className={styles.title}>exclude this session ?</h1>
        <i className="paperflite-close" onClick={onClose} />
      </Slider.Header>
      <Slider.Body>
        <p className={styles.content}>
        This session will be excluded from your current, past and all future analytics across Conversations, Reports, Daily Digest and Asset Analytics. This will be an account level exclusion for ALL USERS in your organisation.
        </p>

      </Slider.Body>
      <div className={styles.note}>
        NOTE: By clicking on “Include”, you can choose to reverse this decision at any time.
        </div>
      <Slider.Actions>
     
      <Button
          className={styles.excludeButton}
          onClick={onExclude}
          disabled={updating}
          variant="primary"
        >
          {updating ? "Excluding..." : "Exclude"}
        </Button>
        <Button
          className={styles.cancelButton}
          onClick={onClose}
          variant="secondary"
        >
          Cancel
        </Button>
      
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default ExcludeSession;
